import styled from "styled-components"

export const ButtonContainer = styled.div`
  margin-left: auto;
  display: inline-flex;

  & > :first-child {
    color: white;
    font-size: 16px;
    background: #593ba0;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 10px;
    border: none;
    margin-right: 15px;
  }

  & > :last-child {
    color: white;
    font-size: 16px;
    background: #d59f08;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 10px;
    border: none;
  }
`

export const Content = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;

  @media (max-width: 992px) {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;

    ${ButtonContainer} {
      margin-top: var(--gapXS);
    }
  }
`
